export function columnLetter(index) {
  let number = index + 1;
  let label = "";
  while (number > 0) {
    label = String.fromCharCode(65 + ((number - 1) % 26)) + label;
    number = Math.floor((number - 1) / 26);
  }
  return label;
}

export function clipboardValue(value) {
  const text = String(value ?? "").replace(/[\t\r\n]+/g, " ");
  return /^[=+@-]/.test(text.trimStart()) ? `'${text}` : text;
}

export function formatRegistryCell(cell) {
  const detail = cell.getRow().getData().__cells?.[cell.getField()];
  cell.getElement().classList.toggle("registry-cell--changed", Boolean(detail?.changed));
  const content = document.createElement("div");
  if (!detail) {
    content.textContent = String(cell.getValue() ?? "") || "(puste)";
    return content;
  }
  for (const text of detail.lines) {
    const line = document.createElement("div");
    line.className = "school-registry-grid__line";
    line.textContent = text;
    content.append(line);
  }
  if (detail.link) {
    const url = new URL(detail.link.href, window.location.href);
    if (url.origin === window.location.origin && ["http:", "https:"].includes(url.protocol)) {
      const link = document.createElement("a");
      link.href = url.href;
      link.textContent = detail.link.text;
      content.append(link);
    }
  }
  return content;
}

export function readComparisonTable(table) {
  const columns = Array.from(table.querySelectorAll("thead th"), (heading, index) => ({
    key: heading.dataset.field || "comparison_status",
    label: heading.textContent.trim(),
    width: Number.parseInt(table.querySelectorAll("col")[index]?.style.width, 10) || 180,
  }));
  const rows = Array.from(table.querySelectorAll("tbody tr"))
    .filter((row) => row.cells.length === columns.length)
    .map((row, index) => {
      const data = { id: index, __cells: {} };
      Array.from(row.cells).forEach((cell, columnIndex) => {
        const field = columns[columnIndex].key;
        const link = cell.querySelector("a");
        data[field] = cell.dataset.value ?? cell.textContent.trim();
        data.__cells[field] = {
          changed: cell.classList.contains("table-warning"),
          lines: cell.children.length
            ? Array.from(cell.children)
                .filter((child) => child.tagName !== "A")
                .map((child) => child.textContent.trim())
            : [cell.textContent.trim()],
          link: link ? { href: link.getAttribute("href"), text: link.textContent } : null,
        };
      });
      return data;
    });
  return { columns, rows };
}
